export enum RoundType {
  UP,
  LOW,
  NEAR
}
